import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { ThemeProvider } from '@emotion/react';
import { NotificationHost } from '../Notification/NotificationHost';
import { createTheme, toEmotionTheme } from '../Theme/Theme';
import { appendStylesToDocument } from '../util/withCss';
import { FlowWebContext } from './Context';
import { deleteWindowConfiguration, getConfigurationFromWindowOrDefault, setWindowConfiguration } from './FlowWebInternal';
import { globalCss } from './global.css';
import { ModalHost } from './ModalHost';
export var FlowWebProvider = /*#__PURE__*/function (_React$Component) {
  function FlowWebProvider(props) {
    var _this;
    _classCallCheck(this, FlowWebProvider);
    _this = _callSuper(this, FlowWebProvider, [props]);
    _defineProperty(_this, "instanceSymbol", Symbol());
    appendStylesToDocument([globalCss]);
    return _this;
  }
  _inherits(FlowWebProvider, _React$Component);
  return _createClass(FlowWebProvider, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/React.createElement(FlowWebContext.Consumer, null, function () {
        var parentConfiguration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getConfigurationFromWindowOrDefault();
        var configurationProp = _this2.props.configuration;
        var baseConfiguration = configurationProp ? _this2.getMergedConfiguration(parentConfiguration, configurationProp) : parentConfiguration;
        var themeWithDefaults = createTheme(baseConfiguration.theme);
        var configuration = _objectSpread(_objectSpread({}, baseConfiguration), {}, {
          theme: themeWithDefaults
        });
        setWindowConfiguration(_this2.instanceSymbol, {
          configuration: configuration
        });
        return /*#__PURE__*/React.createElement(FlowWebContext.Provider, {
          value: configuration
        }, /*#__PURE__*/React.createElement(ThemeProvider, {
          theme: toEmotionTheme(configuration.theme)
        }, _this2.props.children, /*#__PURE__*/React.createElement(ModalHost, {
          instanceSymbol: _this2.instanceSymbol
        }), /*#__PURE__*/React.createElement(NotificationHost, {
          location: configuration.notificationContainerLocation,
          instanceSymbol: _this2.instanceSymbol
        })));
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      deleteWindowConfiguration(this.instanceSymbol);
    }
  }, {
    key: "getMergedConfiguration",
    value: function getMergedConfiguration(parentConfiguration, configurationOrCallback) {
      var configuration = typeof configurationOrCallback === 'function' ? configurationOrCallback(parentConfiguration) : _objectSpread(_objectSpread({}, parentConfiguration), configurationOrCallback);
      if (!configuration) {
        throw new Error('flow-web received invalid configuration from a `configuration` prop on `FlowWebProvider`. Did you forget to return the configuration?');
      }
      return configuration;
    }
  }]);
}(React.Component);